import { useMelioIntl } from '@melio/ar-domain';
import { Button, Group } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';

import { Filter } from '../types';
import { FiltersToolBar } from './FiltersToolBar';

export type InvoiceTableToolbarProps = {
  onCreateInvoice?: VoidFunction;
  isLoading?: boolean;
  onFilter: (filter: Filter) => void;
  invoiceStatus: Filter;
  search?: string;
  onSearch: (value: string) => void;
};

export const InvoiceTableToolbar = forwardRef<InvoiceTableToolbarProps>(
  ({ onCreateInvoice, onFilter, invoiceStatus, isLoading, search, onSearch, ...props }, ref) => {
    const { formatMessage } = useMelioIntl();

    return (
      <Group data-component="InvoiceTableToolbar" width="full" justifyContent="space-between" {...props} ref={ref}>
        <FiltersToolBar selectedFilter={invoiceStatus} onSelectFilter={onFilter} search={search} onSearch={onSearch} />
        <Button
          variant="primary"
          onClick={() => onCreateInvoice?.()}
          label={formatMessage('ar.dashboard.activities.invoiceTable.create.button.label')}
          data-testid="create-invoice-button"
          isDisabled={isLoading}
        />
      </Group>
    );
  }
);
InvoiceTableToolbar.displayName = 'InvoiceTableToolbar';
